import { render, staticRenderFns } from "./ImportacaoEmAndamento.vue?vue&type=template&id=7fae5dfa&scoped=true"
import script from "./ImportacaoEmAndamento.vue?vue&type=script&lang=js"
export * from "./ImportacaoEmAndamento.vue?vue&type=script&lang=js"
import style0 from "./ImportacaoEmAndamento.vue?vue&type=style&index=0&id=7fae5dfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fae5dfa",
  null
  
)

export default component.exports